import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Hero from '../Hero';

const ChaosMonkeyHero = props => {
  const { align, children, contrast, background } = props;

  const classes = cx('chaosMonkey__hero', {
    'u-flexTop': align === 'top',
  });

  return (
    <Hero
      particles={false}
      contrast={contrast}
      className={classes}
      style={{ backgroundImage: `url(${background})` }}
    >
      {children}
    </Hero>
  );
};

ChaosMonkeyHero.propTypes = {
  contrast: PropTypes.bool,
  children: PropTypes.node,
  align: PropTypes.oneOf(['top']),
  background: PropTypes.string,
};

export default ChaosMonkeyHero;
